import PadraoService from '@/modules/services/padrao.service'
import * as msg from '../mensagens/servicos.msg'

class ServicoService extends PadraoService {
  constructor() {
    // Rota, Biblioteca de mensagens
    super('servicos', msg)
  }
}

export default new ServicoService()
